(function () {
  function bind(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.__swBound) return;
      card.__swBound = true;

      var media = card.querySelector('.card__media');
      if (!media) return;

      // Ensure there's a single overlay image for previews
      var preview = media.querySelector('img.variant-preview');
      if (!preview) {
        preview = document.createElement('img');
        preview.className = 'variant-preview';
        preview.setAttribute('alt', '');
        preview.setAttribute('loading', 'lazy');
        media.appendChild(preview);
      }

      // Helper to set srcset/src from data-img-* attributes on a swatch
      function applyFromSwatch(btn) {
        var sizes = [1066, 940, 720, 533, 360, 165]; // descending to build srcset nicest-first
        var any = false;
        var srcset = [];
        sizes.forEach(function (w) {
          var v = btn.getAttribute('data-img-' + w);
          if (v) {
            srcset.push(v + ' ' + w + 'w');
            any = true;
          }
        });

        if (any) {
          preview.setAttribute('srcset', srcset.join(', '));
          // Reasonable default src (fallback)
          var src = btn.getAttribute('data-img-533') ||
                    btn.getAttribute('data-img-360') ||
                    btn.getAttribute('data-img-720') ||
                    btn.getAttribute('data-img-165') ||
                    '';
          if (src) preview.setAttribute('src', src);
          card.classList.add('var-preview-on');
        }
      }

      function clearPreview() {
        card.classList.remove('var-preview-on');
        preview.removeAttribute('srcset');
        preview.removeAttribute('src');
      }

      // Bind to ALL swatches within the card (content or badge)
      card.querySelectorAll('.quick-swatches .swatch').forEach(function (btn) {
        btn.addEventListener('mouseenter', function () { applyFromSwatch(btn); });
        btn.addEventListener('focus',      function () { applyFromSwatch(btn); });
      });

      // Clear preview when leaving the card or losing focus from within
      card.addEventListener('mouseleave', clearPreview);
      card.addEventListener('focusout', function () {
        if (!card.contains(document.activeElement)) clearPreview();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
